import { defaultMessageBackend, noValidation } from '@post-office/placement-common-v2';
import {
	PlacementBackend,
	PlacementFrontend,
} from '@post-office/placements--jira-wanjel/jira-nin-saved-filters-menu';

import { SavedFiltersSpotlight } from './saved-filters-spotlight';
import { type MessageTemplateContext } from '../../../index';

type MessageFrontendProps = React.PropsWithChildren<MessageTemplateContext>;

export const MessageBackend = PlacementBackend.createMessageBackend(defaultMessageBackend);

export const MessageFrontend = PlacementFrontend.createMessageFrontend({
	render: {
		validate: noValidation<MessageTemplateContext>(),
		Component: ({ children }: MessageFrontendProps) => {
			return <SavedFiltersSpotlight>{children}</SavedFiltersSpotlight>;
		},
	},
});
